import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Compass, Repeat, UserMinus, CloudRain, HandHeart, Heart } from 'lucide-react';
export function Problem() {
  const problems = [{
    icon: <Compass className="w-5 h-5 text-brand-eucalyptus" strokeWidth={1.5} data-id="element-125" />,
    text: 'Te cuesta tomar decisiones sin miedo, culpa o urgencia.'
  }, {
    icon: <Repeat className="w-5 h-5 text-brand-eucalyptus" strokeWidth={1.5} data-id="element-126" />,
    text: 'Repites patrones en tus relaciones aunque quieres algo distinto.'
  }, {
    icon: <UserMinus className="w-5 h-5 text-brand-eucalyptus" strokeWidth={1.5} data-id="element-127" />,
    text: 'Te adaptas tanto que a veces no sabes qué quieres tú.'
  }, {
    icon: <CloudRain className="w-5 h-5 text-brand-eucalyptus" strokeWidth={1.5} data-id="element-128" />,
    text: 'Funcionas por fuera, pero por dentro algo no está en paz.'
  }, {
    icon: <HandHeart className="w-5 h-5 text-brand-eucalyptus" strokeWidth={1.5} data-id="element-129" />,
    text: 'Has pasado tanto tiempo cuidando a otros que olvidaste escucharte a ti.'
  }, {
    icon: <Heart className="w-5 h-5 text-brand-eucalyptus" strokeWidth={1.5} data-id="element-130" />,
    text: 'Una parte de ti sabe que es momento de volver a escucharse.'
  }];
  return <section className="py-14 md:py-20 bg-brand-cream" data-id="element-131">
      <div className="max-w-4xl mx-auto px-6" data-id="element-132">
        <FadeIn data-id="element-133">
          <h2 className="font-serif text-3xl md:text-4xl text-center text-brand-ink mb-16 max-w-2xl mx-auto leading-tight" data-id="element-134">
            Tal vez no estás perdida. Tal vez solo llevas demasiado tiempo
            viviendo lejos de ti.
          </h2>
        </FadeIn>

        <div className="grid gap-6 max-w-2xl mx-auto" data-id="element-135">
          {problems.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-136">
              <div className="flex items-start gap-5 p-6 rounded-2xl bg-brand-warmwhite border border-brand-sand/40 shadow-sm transition-all hover:shadow-md hover:border-brand-sand" data-id="element-137">
                <div className="mt-1 shrink-0 p-2 bg-brand-sage-light/50 rounded-full" data-id="element-138">
                  {item.icon}
                </div>
                <p className="font-sans text-brand-ink/80 text-lg leading-relaxed" data-id="element-139">
                  {item.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}